/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Header from './header';
import StructuredData from './structured-data';
import GTM from './gtm';
import ApResize, { fireResizeMessage } from './ap-resize';
import './layout.css';

const Layout = ({ children, header }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          publishDate
        }
      }
    }
  `);

  useEffect(() => {
    setTimeout(() => {
      fireResizeMessage(false);
    }, 3600);
  }, []);
  return (
    <>
      <GTM />
      <StructuredData />
      <ApResize />
      {(header ? <Header siteTitle={data.site.siteMetadata.title} /> : false)}
      <div>
        <main>
          {children}
        </main>
        <footer />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.bool,
};

Layout.defaultProps = {
  header: false,
};

export default Layout;
